"use client"

export default function VibrantFooter() {
    return (
        <footer className="bg-gradient-to-r from-purple-100 via-pink-100 to-orange-100 py-12 relative overflow-hidden">
            {/* Decorative Circles */}
            <div className="absolute top-0 left-10 w-32 h-32 bg-purple-300 rounded-full opacity-20 blur-3xl" />
            <div className="absolute bottom-0 right-10 w-40 h-40 bg-pink-300 rounded-full opacity-20 blur-3xl" />

            <div className="max-w-7xl mx-auto px-6 relative z-10">
                {/* Content */}
                <div className="text-center mb-8">
                    <h3 className="text-3xl font-black text-transparent bg-clip-text bg-gradient-to-r from-purple-600 via-pink-600 to-orange-600 mb-3">
                        Delícias que Encantam! 🎉
                    </h3>
                    <p className="text-gray-700 font-semibold">
                        Feito com amor e dedicação para você ❤️
                    </p>
                </div>

                {/* Bottom Info */}
                <div className="flex flex-col items-center gap-3 pt-8">
                    <div className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-purple-400 to-pink-400 text-white rounded-full font-bold text-sm">
                        <span>✨</span>
                        <span>POWERED BY SYNCTECH</span>
                        <span>✨</span>
                    </div>
                    <p className="text-xs text-gray-600 font-semibold">
                        © 2026 • Todos os direitos reservados
                    </p>
                </div>
            </div>
        </footer>
    )
}
